import { BaseInput, InputProps } from './BaseInput';
import { InputGroup } from './InputGroup';
import { InputDescription, InputLabel, LabelledInput } from './LabelledInput';

const Input = BaseInput as typeof BaseInput & {
  Group: typeof InputGroup;
  Labeled: typeof LabelledInput;
  Label: typeof InputLabel;
  Description: typeof InputDescription;
};

Input.Group = InputGroup;
Input.Labeled = LabelledInput;
Input.Label = InputLabel;
Input.Description = InputDescription;

export { Input, type InputProps };
